import { RouteRecordRaw } from "vue-router";

import { router } from "../module";

export class RouterHelpers {
  public static registerRoute(route: RouteRecordRaw): void {
    router.addRoute(route);
  }
}
